import React, { Component } from 'react';
import classNames from 'classnames';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { mergeStyles } from 'wix-rich-content-common';

var css_248z = ".MrhsR{font-size:14px;line-height:1.5}[dir] .MrhsR{cursor:pointer}[dir] .MrhsR:hover .lZz20{border-color:var(--ricos-settings-action-color,#000)}.lZz20{box-sizing:border-box;display:inline-block;height:16px;width:16px}[dir] .lZz20{background:#fff;border:1px solid var(--ricos-settings-action-color,rgba(0,0,0,.6));border-radius:50%}[dir=ltr] .lZz20{margin-right:12px}[dir=rtl] .lZz20{margin-left:12px}.lZz20:after{content:\"\";display:block;height:10px;position:relative;top:2px;width:10px}[dir] .lZz20:after{border-radius:50%}[dir=ltr] .lZz20:after{left:2px}[dir=rtl] .lZz20:after{right:2px}.gKMw6{display:none}[dir] .gKMw6:checked+.lZz20{border-color:var(--ricos-settings-action-color,rgba(0,0,0,.6))}[dir] .gKMw6:checked+.lZz20:after{background-color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}";
var styles = {"radioGroup":"MrhsR","radioGroup_button":"lZz20","radioGroup_input":"gKMw6"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class RadioGroup extends Component {
  constructor(props) {
    super(props);
    this.styles = mergeStyles({ styles, theme: props.theme });
    this.state = { focusIndex: -1 };
    this.id = `group_${Math.floor(Math.random() * 9999)}`;
    this.inputs = {};
  }
  onKeyDown(event) {
    if (this.props.dataSource.length < 2) {
      return;
    }
    const index = this.state.focusIndex === -1 ? 0 : this.state.focusIndex;
    let nextIndex = -1;
    switch (event.key) {
      case "ArrowLeft":
      case "ArrowUp":
        nextIndex = index === 0 ? this.props.dataSource.length - 1 : index - 1;
        break;
      case "ArrowRight":
      case "ArrowDown":
        nextIndex = (index + 1) % this.props.dataSource.length;
        break;
      case "Tab":
        this.setState({ focusIndex: -1, innerNavigation: false });
        break;
      case " ":
      case "Enter":
        event.target.click();
        break;
    }
    if (nextIndex > -1) {
      this.setState({ focusIndex: nextIndex, innerNavigation: true });
    }
  }
  componentDidUpdate() {
    var _a;
    if (this.state.focusIndex !== -1) {
      (_a = this.inputs[`${this.id}_${this.state.focusIndex}`]) == null ? void 0 : _a.focus();
    }
  }
  saveInputRef(el, inputId) {
    if (!this.inputs[inputId]) {
      this.inputs[inputId] = el;
    }
  }
  render() {
    const { dataSource, value, className, onChange, ariaLabelledBy } = this.props;
    const { styles: styles2 } = this;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "aria-labelledby": ariaLabelledBy,
        role: "radiogroup",
        tabIndex: -1,
        className: classNames(styles2.radioGroup, className),
        onKeyDown: (e) => this.onKeyDown(e)
      },
      dataSource.map((option, i) => {
        const checked = option.value === value;
        const a11yProps = {
          "aria-checked": checked,
          "aria-label": option.labelText
        };
        const inputId = `${this.id}_${i}`;
        return /* @__PURE__ */ React.createElement(
          "label",
          {
            htmlFor: inputId,
            tabIndex: 0,
            name: `${this.id}`,
            key: option.value,
            ref: (el) => this.saveInputRef(el, inputId),
            className: styles2.radioGroup,
            "data-hook": option.dataHook,
            onClick: () => onChange(option.value)
          },
          /* @__PURE__ */ React.createElement(
            "input",
            __spreadProps(__spreadValues({
              tabIndex: -1
            }, a11yProps), {
              id: inputId,
              className: styles2.radioGroup_input,
              type: "radio",
              checked
            })
          ),
          /* @__PURE__ */ React.createElement("span", { className: styles2.radioGroup_button }),
          /* @__PURE__ */ React.createElement("span", { className: styles2.radioGroup_label }, option.labelText)
        );
      })
    );
  }
}

export { RadioGroup as default };
//# sourceMappingURL=RadioGroup.js.map
